import { render, staticRenderFns } from "./ImageEffectsPropertiesCreateBody.vue?vue&type=template&id=5ad25143&scoped=true"
import script from "./ImageEffectsPropertiesCreateBody.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageEffectsPropertiesCreateBody.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ImageEffectsPropertiesCreateBody.vue?vue&type=style&index=0&id=5ad25143&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad25143",
  null
  
)

export default component.exports